(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marigold-mantras"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const root=document.getElementById('marigold-mantras');
  if(!root||root.dataset.ready==='true')return;
  root.dataset.ready='true';

  const field=root.querySelector('.mm-field');
  const reveal=root.querySelector('.mm-reveal');
  const titleEl=root.querySelector('.mm-mantra');
  const artistEl=root.querySelector('.mm-artist');
  const meaningEl=root.querySelector('.mm-meaning');
  const contextEl=root.querySelector('.mm-context');
  const playerWrap=root.querySelector('.mm-player-wrap');
  const sourceLink=root.querySelector('.mm-source');
  const close=root.querySelector('.mm-close');
  const again=root.querySelector('.mm-again');
  const flowerSrc='https://cdn.shopify.com/s/files/1/0918/4910/files/marigold-clean-approved.png?v=1790917326';

  const flowers=[
    {title:'Om Shantih',artist:'Sharon Gannon',meaning:'A prayer for peace within, peace around us, and peace throughout existence.',source:'https://whiteswanrecords.bandcamp.com/album/sharanam'},
    {title:'Lokah Samastah Sukhino Bhavantu',artist:'Sharon Gannon',meaning:'May all beings everywhere be happy and free.',youtube:'OLDRpB_4fkQ',source:'https://www.youtube.com/watch?v=OLDRpB_4fkQ'},
    {title:'The 23rd Psalm',artist:'Bobby McFerrin',meaning:'A prayer of trust, guidance, protection, and being carried through darkness.',youtube:'bJixdpZ5m1o',source:'https://www.youtube.com/watch?v=bJixdpZ5m1o'},
    {title:'Imagine',artist:'John Lennon',meaning:'A vision of humanity beyond division, possession, and conflict.',youtube:'rAn-AWXtHv0',source:'https://www.youtube.com/watch?v=rAn-AWXtHv0'},
    {title:'Sri Venkateswara Suprabhatam',artist:'M. S. Subbulakshmi',meaning:'A sacred morning invocation awakening and praising Lord Venkateswara.',context:'Lord Venkateswara is a beloved form of Vishnu, associated with protection, abundance, compassion, and grace.',youtube:'krGYd5tZe0A',source:'https://www.youtube.com/watch?v=krGYd5tZe0A'},
    {title:'Ram',artist:'Neem Karoli Baba / Maharaj-ji',meaning:'The divine name repeated as remembrance, love, devotion, and refuge.',context:'Neem Karoli Baba, known as Maharaj-ji, was an Indian saint whose teachings centered on love, service, remembrance of God, and compassion.',audio:'https://babaneebkarorimaharaj.com/wp-content/uploads/2021/09/Neem-Karoli-Baba-chanting-RAMs-name-2-daily-practice.mp3',source:'https://babaneebkarorimaharaj.com/'},
    {title:'Speaking Tree',artist:'Joy Harjo',meaning:'A meditation on kinship with the living world and the act of listening.',context:'Joy Harjo is a Muscogee poet, musician, and former U.S. Poet Laureate.',youtube:'xzxZYlHGDhM',source:'https://www.youtube.com/watch?v=xzxZYlHGDhM'},
    {title:'Earth Spirit',artist:'R. Carlos Nakai',meaning:'A contemplative flute piece rooted in breath, land, and stillness.',context:'R. Carlos Nakai is a Native American flutist of Navajo-Ute heritage.',source:'https://canyonrecords.com/product/r-carlos-nakai-earth-spirit-cr-612/'},
    {title:'Om Namah Shivaya',artist:'Krishna Das',meaning:'I bow to the divine presence within all.',youtube:'PTc8X37oJBE',source:'https://www.youtube.com/watch?v=PTc8X37oJBE'},
    {title:'Om Gam Ganapataye Namaha',artist:'Sat-Chit',meaning:'An invocation to Ganesha for wisdom, groundedness, and the clearing of obstacles.',youtube:'HKQmZs_gnSM',source:'https://www.youtube.com/watch?v=HKQmZs_gnSM'},
    {title:'Gayatri Mantra',artist:'Deva Premal',meaning:'A prayer asking divine light to illuminate the mind and awaken wisdom.',youtube:'se_WP1Mh0g8',source:'https://www.youtube.com/watch?v=se_WP1Mh0g8'},
    {title:'My Sweet Lord',artist:'George Harrison',meaning:'A devotional longing for direct experience of the divine, weaving Western praise with Hare Krishna.',youtube:'SP9wms6oEMo',source:'https://www.youtube.com/watch?v=SP9wms6oEMo'},
    {title:'Om Mani Padme Hum',artist:'Women of the World',meaning:'A Tibetan Buddhist mantra invoking compassion and awakening.',youtube:'3IeqzVeAi60',source:'https://www.youtube.com/watch?v=3IeqzVeAi60'},
    {title:'Ong Namo Guru Dev Namo',artist:'Snatam Kaur',meaning:'I bow to the subtle divine wisdom and the teacher within.',youtube:'0nP23NQA8A4',source:'https://www.youtube.com/watch?v=0nP23NQA8A4'},
    {title:'Hanuman Chalisa',artist:'Krishna Das',meaning:'A devotional hymn invoking Hanuman’s courage, strength, devotion, protection, and service.',context:'Hanuman is the beloved devotee of Ram, revered as an embodiment of devotion, courage, and selfless service.',youtube:'W84F5S_YrFs',source:'https://www.youtube.com/watch?v=W84F5S_YrFs'},
    {title:'Om Amriteshwaryai Namaha',artist:'Amma tradition',meaning:'Salutations to the Divine Mother, the energy of immortal bliss.',context:'This mantra is closely associated with Amma, Mata Amritanandamayi.',source:'https://www.amritapuri.org/14068/01birthday.aum/gallery/slideshow'},
    {title:'Wild Geese',artist:'Mary Oliver, read by Mary Oliver',meaning:'A reminder of belonging, self-forgiveness, and our place within the natural world.',youtube:'T_nKg3TBzpU',source:'https://www.youtube.com/watch?v=T_nKg3TBzpU'},
    {title:'Mindful Breathing',artist:'Trevor Hall feat. Thich Nhat Hanh',meaning:'A meditation on returning to the present moment through the simple awareness of breathing.',youtube:'iiVFNKgWCgc',source:'https://www.youtube.com/watch?v=iiVFNKgWCgc'},
    {title:'Savitri',artist:'Sri Aurobindo · recited by The Mother',meaning:'A spiritual epic about love, death, transformation, and the possibility of a greater consciousness.',context:'The Mother’s recorded recitations are preserved within the Sri Aurobindo tradition.',youtube:'-489F6wnib0',source:'https://www.youtube.com/watch?v=-489F6wnib0'},
    {title:'Dream Variations',artist:'Langston Hughes · Sweet Honey in the Rock',meaning:'A dream of freedom, movement, rest, and belonging beneath an open sky.',youtube:'BBBayE57ywY',source:'https://www.youtube.com/watch?v=BBBayE57ywY'},
    {title:'A Love Supreme: Acknowledgement',artist:'John Coltrane',meaning:'A devotional work of gratitude, surrender, praise, and love of God.',youtube:'Dmx2WuUPVcs',source:'https://www.youtube.com/watch?v=Dmx2WuUPVcs'},
    {title:'The Miracle Mantra of Guru Ram Das',artist:'Gurucharan Khalsa & Gurusangat Singh',meaning:'A journey from personal wisdom into the infinite and back into a life of service.',context:'The album includes Gurucharan’s spoken introduction to the mantra.',youtube:'lbtxHVKULmE',source:'https://www.youtube.com/watch?v=lbtxHVKULmE'},
    {title:'Japji Sahib',artist:'Guru Nanak · recited by Bhai Sahib Singh',meaning:'A foundational Sikh prayer on truth, divine order, humility, remembrance, and living in harmony with the One.',youtube:'KQIeS-hKWPk',source:'https://www.youtube.com/watch?v=KQIeS-hKWPk'},
    {title:'Shanti / Ashtangi',artist:'Madonna',meaning:'A Sanskrit devotional invocation shaped into a modern pop meditation.',youtube:'y8VN8WCMWpE',source:'https://www.youtube.com/watch?v=y8VN8WCMWpE'},
    {title:'Ubi Caritas',artist:'Gregorian chant · Verbum Gloriae',meaning:'Where charity and love are, God is there.',audio:'https://www.verbumgloriae.es/wp-content/uploads/2025/08/Ubi-caritas.ogg',source:'https://www.verbumgloriae.es/project/ubi-caritas/'}
  ];

  let lastIndex=-1;

  const burst=(b)=>{
    const r=b.getBoundingClientRect();
    const cx=r.left+r.width/2;
    const cy=r.top+r.height/2;
    for(let i=0;i<8;i++){
      const p=document.createElement('span');
      const a=(Math.PI*2/8)*i+(Math.random()*.45);
      const d=34+Math.random()*46;
      p.className='mm-burst';
      p.style.left=cx+'px';
      p.style.top=cy+'px';
      p.style.setProperty('--x',(Math.cos(a)*d)+'px');
      p.style.setProperty('--y',(Math.sin(a)*d)+'px');
      p.style.setProperty('--r',((Math.random()*240)-120)+'deg');
      document.body.appendChild(p);
      setTimeout(()=>p.remove(),950);
    }
  };

  const clearPlayer=()=>{
    playerWrap.innerHTML='';
    playerWrap.hidden=true;
  };

  const loadPlayer=(item)=>{
    clearPlayer();
    if(item.youtube){
      const frame=document.createElement('iframe');
      frame.src='https://www.youtube-nocookie.com/embed/'+item.youtube+'?autoplay=1&playsinline=1&rel=0';
      frame.title=item.title+' by '+item.artist;
      frame.allow='autoplay; encrypted-media; picture-in-picture';
      frame.allowFullscreen=true;
      playerWrap.appendChild(frame);
      playerWrap.hidden=false;
      return;
    }
    if(item.audio){
      const audio=document.createElement('audio');
      audio.controls=true;
      audio.autoplay=true;
      audio.preload='none';
      audio.src=item.audio;
      playerWrap.appendChild(audio);
      playerWrap.hidden=false;
    }
  };

  const pickItem=()=>{
    if(flowers.length<2)return flowers[0];
    let i=Math.floor(Math.random()*flowers.length);
    if(i===lastIndex)i=(i+1)%flowers.length;
    lastIndex=i;
    return flowers[i];
  };

  const showItem=(item)=>{
    titleEl.textContent=item.title;
    artistEl.textContent=item.artist || '';
    meaningEl.textContent=item.meaning || '';
    contextEl.textContent=item.context || '';
    contextEl.hidden=!item.context;
    sourceLink.href=item.source || '#';
    sourceLink.hidden=!item.source;
    sourceLink.textContent=item.youtube||item.audio?'open source':'listen at official source';
    reveal.hidden=false;
    requestAnimationFrame(()=>reveal.classList.add('mm-show'));
    loadPlayer(item);
  };

  const catchBloom=(b)=>{
    const item=pickItem();
    b.classList.add('mm-caught');
    burst(b);
    setTimeout(()=>showItem(item),260);
    setTimeout(()=>b.classList.remove('mm-caught'),1500);
  };

  const makeBloom=()=>{
    const b=document.createElement('button');
    const img=document.createElement('img');
    b.type='button';
    b.className='mm-bloom';
    b.setAttribute('aria-label','Catch a marigold');
    img.src=flowerSrc;
    img.alt='';
    b.appendChild(img);
    b.style.setProperty('--size',(42+Math.random()*48)+'px');
    b.style.left=(3+Math.random()*88)+'vw';
    b.style.setProperty('--dur',(14+Math.random()*12)+'s');
    b.style.setProperty('--delay',(-Math.random()*22)+'s');
    b.style.setProperty('--drift',((Math.random()*180)-90)+'px');
    b.addEventListener('click',()=>catchBloom(b));
    field.appendChild(b);
  };

  const makePetal=()=>{
    const p=document.createElement('span');
    p.className='mm-petal';
    p.style.setProperty('--w',(5+Math.random()*9)+'px');
    p.style.left=(2+Math.random()*94)+'vw';
    p.style.setProperty('--dur',(12+Math.random()*12)+'s');
    p.style.setProperty('--delay',(-Math.random()*22)+'s');
    p.style.setProperty('--drift',((Math.random()*150)-75)+'px');
    field.appendChild(p);
  };

  for(let i=0;i<10;i++)makeBloom();
  for(let i=0;i<20;i++)makePetal();

  const hide=()=>{
    reveal.classList.remove('mm-show');
    clearPlayer();
    setTimeout(()=>{reveal.hidden=true},350);
  };
  close.addEventListener('click',hide);
  again.addEventListener('click',()=>{
    hide();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
